import { render, staticRenderFns } from "./TheAdministrationApp.vue?vue&type=template&id=1f0f9806&scoped=true&"
import script from "./TheAdministrationApp.vue?vue&type=script&lang=js&"
export * from "./TheAdministrationApp.vue?vue&type=script&lang=js&"
import style0 from "./TheAdministrationApp.vue?vue&type=style&index=0&id=1f0f9806&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f9806",
  null
  
)

export default component.exports